// @flow

import React, { type Node } from 'react';
import { IfFeature } from '@tectonics/prs/feature';
import { useAllFeatures } from '@tectonics/prs/payment-spec';

import { Separator, SectionTitle } from '../../../../commons/atoms';

import { CashBarcode } from './cash-barcode';
import { CashNumber, CashSplitNumber } from './cash-number';
import { CashSavePDFButton } from './cash-save-pdf-button';
import { CashTicket } from './cash-ticket';
import { CashTips } from './cash-tip-box';
import { OxxopayMapLink } from './oxxopay-map-link';
import { PagosnetInstructions } from './pagosnet-instructions';

export function CashPendingPage(): Node {
  const allFeatures = useAllFeatures();

  return (
    <>
      <p>Usa los siguientes datos para completar tu compra:</p>

      <CashTicket allFeatures={allFeatures} />

      <Separator pattern="dotted" />

      <IfFeature allFeatures={allFeatures} wanted="display_cash_barcode">
        <CashBarcode />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="display_argentine_cash_barcode">
        <CashBarcode />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="display_cash_number">
        <CashSplitNumber />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="display_pagosnet_number">
        <SectionTitle>Usa esto número de recaudación para realizar tu pago:</SectionTitle>
        <CashSplitNumber />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="display_argentine_cash_number">
        <CashNumber />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="display_cash_instructions">
        <OxxopayMapLink />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="action_cash_save_pdf">
        <CashSavePDFButton />
      </IfFeature>

      <Separator pattern="dotted" />

      <IfFeature allFeatures={allFeatures} wanted="display_argentine_cash_tips">
        <CashTips />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="display_pagosnet_tip">
        <PagosnetInstructions/>
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="action_pagosnet_save_pdf">
        <CashSavePDFButton/>
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="action_argentine_cash_save_pdf">
        <CashSavePDFButton />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="display_cash_tips">
        <CashTips />
      </IfFeature>
    </>
  );
}
